import useReveal from "../hooks/useReveal";
import { faqs } from "../mock/mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function FAQ() {
  const [ref, inView] = useReveal();

  return (
    <section className="py-24 md:py-32 bg-[#FBF8F3]">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div ref={ref} className={`text-center mb-14 reveal ${inView ? "in-view" : ""}`}>
          <p className="text-[#A17E4A] tracking-[0.25em] uppercase text-xs mb-4">FAQ</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2A2521]">
            Your Top Questions Answered
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-xl border border-[#EAE3D8] px-6 shadow-sm"
            >
              <AccordionTrigger className="text-left font-serif text-lg text-[#2A2521] hover:no-underline hover:text-[#A17E4A] py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#6B6259] leading-relaxed text-base pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
